// extracted by mini-css-extract-plugin
export default {"allBoard":"yZeGXT9m","mobile":"mobile","icon":"QC2skW8c"};